import SiteSettings from 'src/siteSetting';

export const ADMIN_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 4
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 6
    }
]

export const ADMIN_LO_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 4
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 6
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 5
    }
]

export const LO_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 6
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 4
    }
]

export const LOAN_PROCESSOR_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Funded",
        key: "my_funded",
        order_id: 3
    }
]

export const LO_BACKEND_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 6
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 4
    }
]

export const APP_ADMIN_TABS = [
    {
        title: "Uw Queue",
        key: "uw_queue",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 4
    },
    {
        title: "Funded",
        key: "completed",
        order_id: 5
    }
]

export const APP_LO_TABS = [
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "Funded",
        key: "completed",
        order_id: 4
    }
]

export const UNDERWRITTER_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 6
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 4
    }
]
export const APP_ADMIN_LO_TABS = [
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 0
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
]
